import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import domain from ".././../../../domain";
import { Button } from "mdbreact";
class Session extends Component {
  constructor(props) {
    super(props);
    this.state = {
      session: props.data,
      alert: null,
    };
  }

  onDelete(e) {
    //       console.log(e.target)
    e.preventDefault();
    let r = window.confirm("Do you want to delete session details");
    if (r) {
      let sessionId = this.state.session.course_session_id;
      console.log(sessionId);
      axios
        .delete(`${domain.DBServer}/delete-session/${sessionId}`)
        .then((response) => {
          console.log(response.data);
          if (response.data === 1) {
            alert("Session details deleted Successfully");
            window.location.reload();
          } else {
            alert("Error while deletion");
            window.location.reload();
          }
        })
        .catch((err) => console.log(err));
    } else return false;
  }

  render() {
    return (
      <li className="list-group-item">
        {console.log("session details" + this.state.session)}
        <h5>
          {this.state.session.lecturer_name +
            " " +
            this.state.session.title +
            " " +
            this.state.session.course_id +
            " " +
            this.state.session.start_time +
            " " +
            this.state.session.end_time}
        </h5>
        <Link
          className="btn blue"
          to={`/edit-session/${this.state.session.course_session_id}`}
        >
          {" "}
          Edit
        </Link>
        <Button
          ref="dialog"
          color="secondary"
          name="delete"
          onClick={this.onDelete.bind(this)}
        >
          Delete
        </Button>
      </li>
    );
  }
}

export default Session;
